export default __webpack_public_path__ + "static/media/performance.5dce4ec0.png";